export default function CInputValidation() {
  return <h2>C Input Validation</h2>;
}
